import { IMemberFromNetworkOutput } from '../models/interfaces/iMemberFromNetworkOutput';
import { IGetEventsOutput } from '../models/interfaces/iGetEventsOutput';
import { IFilterForOrgs } from "../models/interfaces/memberProfile/iFilterForOrgs";
import { IFilterForCities } from "../models/interfaces/memberProfile/iFilterForCities";
import { IAddEditLocationsOutput } from "../models/interfaces/iAddEditLocationOutput";
import DataService from "../../../services/client/classes/dataService";
import { IAddEditSocialMediaOutput } from "../models/interfaces/iAddEditSocialMediaOutput";
import { IGetListOfDegreesOutput } from "../models/interfaces/memberProfile/iGetListOfDegreesOutput";

class CommonService extends DataService {
  constructor() {
    super('/private/database/');
  }

  updateOrganizationImage(data: any): JQuery.jqXHR<any> {
    return this.post('updateOrganizationImage/', data);
  }

  searchMembersInNetwork(name: string = '', isGlobal: boolean = false): JQuery.jqXHR<any> {
    return this.get('searchMembersInNetwork/', { name, isGlobal });
  }

  shareWithMembers(data: IMemberFromNetworkOutput): JQuery.jqXHR {
    return this.post('shareWithMembers/', data);
    }

  getCauses(): JQuery.jqXHR<any> {
    return this.get('getCauses/');
  }

    getListOfOrgs(data: IFilterForOrgs): JQuery.jqXHR<any> {
        return this.post('getListOfOrgs/', data);
    }

  getListOfEventOrgs(data: IFilterForOrgs): JQuery.jqXHR<any> {
        return this.post('getListOfEventOrgs/', data);
    }

    getListOfCities(data: IFilterForCities): JQuery.jqXHR<any> {
        return this.post('getListOfCities/', data);
    }

  getListOfGroupActivityTypes(): JQuery.jqXHR<any> {
        return this.get('getListOfGroupActivityTypes/');
    }

  getListOfGroupActivityRestrictions(): JQuery.jqXHR<any> {
        return this.get('getListOfGroupActivityRestrictions/');
    }

    getListOfMajors(): JQuery.jqXHR<any> {
        return this.post('getListOfMajors/');
    }
    getListOfDegrees(data: IGetListOfDegreesOutput): JQuery.jqXHR<any> {
        return this.post('getListOfDegrees/', data);
    }

  getStates(): JQuery.jqXHR<any> {
    return this.get('getStates/');
    }
  
  changeOrganizationLocations(data: IAddEditLocationsOutput): JQuery.jqXHR<any> {
    return this.post('changeOrganizationLocations/', data);
  }

  changeOrganizationSocialMedia(data: IAddEditSocialMediaOutput): JQuery.jqXHR<any> {
    return this.post('changeOrganizationSocialMedia/', data);
  }

  getProgressBarNodes(is_admin: number): JQuery.jqXHR<any> {
    return this.get('getProgressBarNodes/?is_admin='+is_admin );
  }
}

export default new CommonService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/commonService.ts